import {Printd} from "printd";

/**
 * @htmlId id del fragmento de HTML que se va a mostrar en la impresion
 * @papel el papel de la imprerion (carta | oficio) -> Defecto: carta
 * @orientacion orientacion del papel (horizontal | vertical) -> Defecto: horizontal
 * @color color del contenido de la tabla -> Defecto: black
 * @tamanoLetra tablano de la letra del contenido de la tabla (ej: 7pt) -> Defecto: 6.5pt
 * @otroCss estilo css extra para la impresion (Ej: `h1: { color: red; }`)
 */
export class Reporte {
    htmlId = '';
    papel = 'carta';
    orientacion = 'horizontal';
    color = 'black';
    tamanoLetra = '8pt';
    otroCss = '';

    /**
     * @param htmlId id del fragmento de HTML que se va a mostrar en la impresion
     */
    constructor(htmlId: string) {
        this.htmlId = htmlId;
    }

    /**
     * Metodo para imprimir
     */
    imprimir() : void  {
        let papel = ""
        if(this.papel === "oficio"){
            papel = this.orientacion === 'horizontal' ? "330mm 220mm" : "220mm 330mm"
        } else {
            papel = this.orientacion === 'horizontal' ? "280mm 220mm" : "220mm 280mm"
        }

        const d = new Printd()
        const css = `
                   @media print {
                      @page {
                        size:  ${papel};
                        margin: 0.8cm 1cm 1cm 1.2cm;
                      }
                      .encabezado{
                        font-size: 7.5pt;
                      }
                      .subtitulo{
                        font-size: 9pt;
                      }
                      table {
                        width: 100%;
                        border-collapse: collapse;
                      }
                      tr {
                            padding: 0;
                            margin: 0;
                      }
                      td, th {
                        font-family: sans-serif;
                        font-size: ${this.tamanoLetra} !important;
                        border: 1px solid #cecfd5;
                        padding: 1px 5px;
                        color: ${this.color};
                        width: auto;
                      }
                      td span {
                           display: inline-block;
                           float: left;
                           box-sizing: border-box;
                           padding-left: 3px;
                      }
                      .noborde{
                        border:none
                      }
                      .borde_arriba{
                          border-top: 1px solid black;
                          border-right: none
                          border-bottom: none;
                          border-left: none;
                      }
                      .noprint{
                        display:none
                      }
                      .ocultar {
                          display: none;
                        }
                      .showOnlyPrint{
                        display:inline
                      }
                      .print_center{
                         text-align:center
                      }
                      .print_left{
                         text-align:left
                      }
                      .print_right{
                         text-align:right
                      }
                      .contenedor {
                        position: relative;
                      }
                      .imagen2 {
                          position: absolute;
                          left: 0;
                          top: 0;
                          width: 100%;
                      }
                      ${this.otroCss}
                  }
              `;
        const div = document.getElementById(this.htmlId) as HTMLDivElement;

        d.print(div, [css]);
    }
}